import { useRef, useEffect } from 'react'

export const usePrevious = <Value>(value: Value) => {
  const ref = useRef<Value>()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}
